import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const HourColumn = ({ value, className, ...rest }) => (
  <td
    className={classnames(
      'text-right hours',
      {
        'text-muted': !value,
      },
      className,
    )}
    {...rest}
  >
    {!value && value !== 0 ? null : value.minuteToTime()}
  </td>
);
HourColumn.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string,
};
HourColumn.defaultProps = {
  value: null,
  className: null,
};

export default HourColumn;
